import { useConfig } from '@common/Hooks/useConfig';
import SlidePanelHeader from '@common/SlidePanel/components/SlidePanelHeader';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';

function NavHeader({
    navigation,
    backButtonClick = null,
    setIsNavOpen,
    onStoreSelectClick,
    onLanguageSelectClick,
    hasMultipleLanguages,
    uuids,
    tabIds,
    unisexTabIds,
    isCountrySelect
}) {
    const config = useConfig();
    const { lvl } = navigation;
    const name = getTranslatedPropertyFromContext(navigation, 'name', config);
    const isMobileMenuRefresh = config.isActiveFeature('PLT-34079_mobile_nav_refresh_2023');

    const navigationVisibilityLevel = 0;

    const handleClose = () => {
        setIsNavOpen(false);
    };

    const levelCheck = lvl > navigationVisibilityLevel;

    return (
        <SlidePanelHeader
            customClass={isMobileMenuRefresh ? 'slide-panel-header--no-border' : undefined}
            hasHeaderSearch={isMobileMenuRefresh && !isCountrySelect}
            hasLanguageSelect={!levelCheck && hasMultipleLanguages}
            hasLogo={!levelCheck || isMobileMenuRefresh}
            hasStoreSelect={!levelCheck && !isMobileMenuRefresh}
            icon="palette_close"
            isCountrySelect={isCountrySelect}
            tabIds={tabIds}
            theme="mod3"
            title={levelCheck ? name : null}
            unisexTabIds={unisexTabIds}
            uuids={uuids}
            onBackClick={levelCheck ? backButtonClick : null}
            onCloseClick={handleClose}
            onLanguageSelectClick={onLanguageSelectClick}
            onStoreSelectClick={levelCheck ? null : onStoreSelectClick}
        />
    );
}

export default NavHeader;
